import { Platform, View } from 'react-native';
import React, { useCallback, useEffect } from 'react';
import {
  Banner,
  Footer,
  Input,
  KeyboardScreenContainer,
  Text,
} from '~/components';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import useMarisaAutoForm from '~/stores/marisaAutoForm';
import type { MarisaAutoStepsProps } from '../..';
import { journeyLogUseCase } from '~/useCases/PSF/JourneyLogUseCase';
import { useUserInfoStore } from '~/stores/userInfo';

const schema = yup
  .object()
  .shape({
    licensePlate: yup
      .string()
      .required('A placa do veículo é obrigatória')
      .min(7, 'A placa não é válida'),
  })
  .required();

interface LicensePlateForm {
  licensePlate: string;
}

const Plate = ({ onContinue }: MarisaAutoStepsProps) => {
  const id = useUserInfoStore((state) => state.user?.id);
  const { setLicensePlate } = useMarisaAutoForm();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<LicensePlateForm>({
    resolver: yupResolver(schema),
  });

  const onSubmit = useCallback(
    (data: LicensePlateForm) => {
      setLicensePlate(data.licensePlate.toUpperCase());

      onContinue();
    },
    [onContinue, setLicensePlate]
  );

  useEffect(() => {
    if (id) {
      journeyLogUseCase(useUserInfoStore.getState().user, 'AUTO');
    }
  }, [id]);

  return (
    <KeyboardScreenContainer
      footer={
        <View
          className={`flex xl:hidden ${
            Platform.OS === 'web' ? 'py-4 px-6' : ''
          }`}
        >
          <Footer
            backButtonLabel="Pular"
            onBack={() => onContinue()}
            onSubmit={handleSubmit(onSubmit)}
          />
        </View>
      }
    >
      <View className="flex-1 container mx-auto xl:flex-row xl:pt-12 xl:pb-24">
        <Banner type="marisa-auto" />

        <View className="mt-8 xl:mt-0 px-6 flex-1 xl:ml-24">
          <Text className="text-xl mb-4 text-gray-600">
            Olá, bem vindo(a) ao{' '}
            <Text className="text-primary-600">Seguro Auto</Text>
          </Text>

          <Text className="text-gray-400 text-sm mb-8">
            Informe a placa do seu veículo ou toque em pular para continuar.
          </Text>

          <Input
            name="licensePlate"
            label="Qual a placa do seu veículo?"
            placeholder="Insira a placa do seu veículo"
            control={control}
            maskConfig={{
              type: 'custom',
              mask: 'AAA9S99',
            }}
            maxLength={7}
            error={errors.licensePlate?.message}
          />

          <Footer
            className="hidden"
            backButtonLabel="Pular"
            onBack={() => onContinue()}
            onSubmit={handleSubmit(onSubmit)}
          />
        </View>
      </View>
    </KeyboardScreenContainer>
  );
};

export default Plate;
